<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/factory-product">
                    <icon name="tshirt"></icon>
                    สินค้าโรงงานทั้งหมด
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/import-factory-product">
                    <icon name="download"></icon>
                    รายการนำเข้า
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/export-factory-product">
                    <icon name="upload"></icon>
                    รายการนำออก
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "factory-product-layout"
    }
</script>

<style scoped>

</style>